import {
  getMultiStepQuizV2WithLoaderTemplate,
  getMultiStepQuizV2Template,
  getVueMultiStepQuizV2,
} from "../../shortcodes/templates";

let multiStepQuiz = null;
const visualizeMultiStepQuizV2 = content => {
  multiStepQuiz = content.querySelectorAll('[data-wrapper-id="multi-step-quiz-v2"]');

  if (multiStepQuiz.length > 0) {
    multiStepQuiz.forEach(item => {
      const noLoader = !!item.dataset.noLoader;
      if (noLoader) {
        item.innerHTML = getMultiStepQuizV2Template();
      } else {
        item.innerHTML = getMultiStepQuizV2WithLoaderTemplate();
      }
    });
  }
};

const serializeMultiStepQuizV2 = content => {
  const multiStepQuizWidget = content.querySelectorAll('[data-wrapper-id="multi-step-quiz-v2"]');
  if (multiStepQuizWidget.length > 0) {
    multiStepQuizWidget.forEach(item => {
      const quizData = item.getAttribute("data-multi-step-quiz-data");
      const noLoader = !!item.dataset.noLoader;
      item.innerHTML = getVueMultiStepQuizV2(quizData, !noLoader);
    });
  }
};

export { visualizeMultiStepQuizV2, serializeMultiStepQuizV2 };
